// Convert time to hours and minutes
export const calcTime = time => {
  const hours = Math.floor(time / 60);
  const mins = time % 60;
  return `${hours}h ${mins}m`;
};
// Convert a number to money formatting
export const convertMoney = money => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
  });
  return formatter.format(money);
};

export const isPersistedState = stateName => {
  const sessionState = sessionStorage.getItem(stateName);
  return sessionState && JSON.parse(sessionState);
};

// Convert a movie title into a URL-safe slug
// e.g. "The Dark Knight" → "the-dark-knight"
export const slugify = text =>
  (text || '')
    .toLowerCase()
    .normalize('NFD')                    // decompose accented chars
    .replace(/[\u0300-\u036f]/g, '')     // strip accent marks
    .replace(/[^a-z0-9]+/g, '-')        // non-alphanumeric → dash
    .replace(/^-+|-+$/g, '');           // trim leading/trailing dashes

// Build the canonical movie path: /movie/the-dark-knight-155
export const movieUrl = (id, title) => `/movie/${slugify(title)}-${id}`;

// Extract the numeric TMDB id from a slug like "the-dark-knight-155"
// Falls back to treating the whole string as an id for legacy numeric-only slugs
export const movieIdFromSlug = slug => {
  const match = slug && slug.match(/(\d+)$/);
  return match ? match[1] : slug;
};